import { render, staticRenderFns } from "./ArchivedBoards.vue?vue&type=template&id=6de25c00&"
import script from "./ArchivedBoards.vue?vue&type=script&lang=js&"
export * from "./ArchivedBoards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports